// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-page-delegates {
  padding: 1rem;
}
.lsn-page-delegates .link-jump-to-content {
  position: absolute;
  min-width: 200px;
  background-color: var(--main-white);
  box-shadow: 0px 0px 0px 1px var(--main-primary-color) inset;
  cursor: pointer;
  top: inherit;
  margin-top: -1rem;
  margin-left: -1rem;
  transition: height 0.5s;
  height: 0;
}
.lsn-page-delegates .link-jump-to-content a {
  width: 100%;
  height: 100%;
  display: block;
  padding: 4px 10px 3px 20px;
  outline: none;
  color: var(--main-primary-color);
  opacity: 0;
}
.lsn-page-delegates .link-jump-to-content:active,
.lsn-page-delegates .link-jump-to-content:visited,
.lsn-page-delegates .link-jump-to-content:focus,
.lsn-page-delegates .link-jump-to-content:focus-within {
  height: 1.5rem;
}
.lsn-page-delegates .link-jump-to-content:active a,
.lsn-page-delegates .link-jump-to-content:visited a,
.lsn-page-delegates .link-jump-to-content:focus a,
.lsn-page-delegates .link-jump-to-content:focus-within a {
  opacity: 1;
  transition: opacity 0.5s 0.5s;
}
.lsn-page-delegates h1 {
  margin-top: 0;
  margin-bottom: 0;
}
.lsn-page-delegates .lsn-no-delegates-requests {
  color: var(--main-dark-orange);
  text-align: center;
}
.lsn-page-delegates .delegates-wrapper {
  padding: 0.45rem 0;
  background-color: var(--main-bg-color-darker);
  border-radius: var(--main-border-radius);
  border: var(--main-border-width) solid var(--main-border-color);
}
.lsn-page-delegates #delegates {
  row-gap: 1rem;
  display: flex;
  flex-direction: column;
}
.lsn-page-delegates .delegates-header-wrapper {
  align-items: center;
  margin-bottom: 20px;
  row-gap: 10px;
}
.lsn-page-delegates .delegates-list-bottom-actions {
  margin-top: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/manage/delegates/ListDelegates/Delegates.less"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AAFA;EAII,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,2DAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,SAAA;AACJ;AAdA;EAgBM,WAAA;EACA,YAAA;EACA,cAAA;EACA,0BAAA;EACA,aAAA;EACA,gCAAA;EACA,UAAA;AACN;AAEI;;;;EAIE,cAAA;AAAN;AAJI;;;;EAOI,UAAA;EACA,6BAAA;AAGR;AApCA;EAuCI,aAAA;EACA,gBAAA;AAAJ;AAxCA;EA4CI,8BAAA;EACA,kBAAA;AADJ;AA5CA;EAiDI,kBAAA;EACA,6CAAA;EACA,wCAAA;EACA,+DAAA;AAFJ;AAlDA;EAwDI,aAAA;EACA,aAAA;EACA,sBAAA;AAHJ;AAvDA;EA8DI,mBAAA;EACA,mBAAA;EACA,aAAA;AAJJ;AA5DA;EAoEI,gBAAA;AALJ","sourcesContent":[".lsn-page-delegates {\n  padding: 1rem;\n\n  .link-jump-to-content {\n    position: absolute;\n    min-width: 200px;\n    background-color: var(--main-white);\n    box-shadow: 0px 0px 0px 1px var(--main-primary-color) inset;\n    cursor: pointer;\n    top: inherit;\n    margin-top: -1rem;\n    margin-left: -1rem;\n    transition: height .5s;\n    height: 0;\n\n    a {\n      width: 100%;\n      height: 100%;\n      display: block;\n      padding: 4px 10px 3px 20px;\n      outline: none;\n      color: var(--main-primary-color);\n      opacity: 0;\n    }\n\n    &:active,\n    &:visited,\n    &:focus,\n    &:focus-within {\n      height: 1.5rem;\n\n      a {\n        opacity: 1;\n        transition: opacity .5s .5s;\n      }\n    }\n  }\n\n  h1 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  .lsn-no-delegates-requests {\n    color: var(--main-dark-orange);\n    text-align: center;\n  }\n\n  .delegates-wrapper {\n    padding: .45rem 0;\n    background-color: var(--main-bg-color-darker);\n    border-radius: var(--main-border-radius);\n    border: var(--main-border-width) solid var(--main-border-color);\n  }\n\n  #delegates {\n    row-gap: 1rem;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .delegates-header-wrapper {\n    align-items: center;\n    margin-bottom: 20px;\n    row-gap: 10px;\n  }\n\n  .delegates-list-bottom-actions {\n    margin-top: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
